
export function navSticky(): void {
    const elements = document.querySelectorAll<HTMLElement>('[data-nav-sticky]');

    if (elements.length === 0) return;

    elements.forEach((element) => { // This adds a small div for the observer to keep track of. Putting it before the nav since position fixed will remove nav from docmument flow. 
        const placeholderDiv = document.createElement('div');
        placeholderDiv.className = 'nav-sticky-sentinel';
        placeholderDiv.style.height = '1px';
        placeholderDiv.style.width = '100%';
        placeholderDiv.style.pointerEvents = 'none';
        placeholderDiv.style.visibility = 'hidden';

        element.parentNode.insertBefore(placeholderDiv, element); // 

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        element.classList.add('nav-sticky');
                    } else {
                        element.classList.remove('nav-sticky');
                    }
                });
            },
            {
                threshold: 0,
                rootMargin: '0px 0px 0px 0px'
            }
        );

        observer.observe(placeholderDiv);
    });
}
